import React from 'react'
import { Visualizar } from '@newspacebpo/mf_protocolo_bfveic'
const VisualizarPage = (props) => {
    return (
            <Visualizar {...props}/>
    );
};

export { VisualizarPage };